import React from 'react';

import styled from 'styled-components';

const SideColumn = styled.div`
  flex: 1;
  padding-top: 20px;
  padding-bottom: 30px;
`;

const SideColumnTitle = styled.div`
  font-size: 16px;
  font-family: var(--font-bold);
  display: flex;
  flex-flow: row;
  gap: 10px;
  align-items: center;
`;

const IconBadge = styled.div`
  background-image: linear-gradient(to bottom, var(--mint-pale), var(--mint-soft));
  padding: 3px;
  border-radius: 4px;
  line-height: 0;

  &.orange {
    background-image: linear-gradient(to bottom, var(--gold-pale), var(--gold-soft));
  }
`;

const List = styled.ul`
  margin-top: 15px;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;

  li {
    color: var(--text-secondary);
    font-size: 14px;
    display: flex;
    align-items: baseline;

    & + li {
      margin-top: 10px;
    }

    &::before {
      content: '';
      width: 4px;
      height: 4px;
      min-width: 4px;
      border-radius: 50%;
      margin-right: 10px;
      flex-shrink: 0;
      position: relative;
      top: -1px;
    }
  }
`;

const StrengthsList = styled(List)`
  li::before {
    background-color: var(--positive-green);
  }
`;

const LimitationsList = styled(List)`
  li::before {
    background-color: var(--inactive-orange);
  }
`;

const NoData = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
  margin-top: 15px;
`;

type Props = {
  strengths: string[];
  limitations: string[];
};

const CompetitiveAdvantagesImprovements = ({ strengths, limitations }: Props) => {
  return (
    <>
      <SideColumn data-test-id="category-breakdown-advantages">
        <SideColumnTitle>
          <IconBadge>
            <img src="/icons/sentiment-satisfied-green.svg" width="16" height="16" />
          </IconBadge>
          Your Competitive Advantage
        </SideColumnTitle>
        {strengths.length > 0 ? (
          <StrengthsList>
            {strengths.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </StrengthsList>
        ) : (
          <NoData data-test-id="category-breakdown-advantages-empty">No data</NoData>
        )}
      </SideColumn>
      <SideColumn data-test-id="category-breakdown-improvements">
        <SideColumnTitle>
          <IconBadge className="orange">
            <img src="/icons/sentiment-dissatisfied.svg" width="16" height="16" />
          </IconBadge>
          Where You Need to Improve
        </SideColumnTitle>
        {limitations.length > 0 ? (
          <LimitationsList>
            {limitations.map((l, i) => (
              <li key={i}>{l}</li>
            ))}
          </LimitationsList>
        ) : (
          <NoData data-test-id="category-breakdown-improvements-empty">No data</NoData>
        )}
      </SideColumn>
    </>
  );
};

export default CompetitiveAdvantagesImprovements;
